<template>
  <Modal
    title="Create Date Widget"
    @closeModal="$emit('closeModal')"
    :okButtonLabel="'Create'"
    :okFunction="createWidget"
    :modalStyles="{ width: '500px' }"
    :disabled="widgetName.length < 3"
    :cancelButtonLabel="'Cancel'"
  >
    <template #body>
      <div class="form-group">
        <label>Widget Name</label>
        <input
          type="text"
          class="form-control"
          v-model="widgetName"
          placeholder="Enter widget name"
        />
      </div>

      <div class="form-group">
        <label>Widget Type</label>
        <select class="form-control" v-model="widgetType">
          <option :value="DATE_WIDGET_TYPE.TODAY">Today</option>
          <option :value="DATE_WIDGET_TYPE.WEEK">Week</option>
        </select>
      </div>

      <div class="form-group">
        <label>Language</label>
        <select class="form-control" v-model="language">
          <option value="en">English</option>
          <option value="sv">Swedish</option>
        </select>
      </div>

      <div v-if="widgetType === DATE_WIDGET_TYPE.TODAY" class="form-group">
        <label>Date Format</label>
        <select class="form-control" v-model="dateFormat">
          <option :value="DATE_FORMAT.EU_FORMAT">
            {{ formatCurrentDate(DATE_FORMAT.EU_FORMAT) }}
          </option>
          <option :value="DATE_FORMAT.EU_FORMAT_DASH">
            {{ DATE_FORMAT.EU_FORMAT_DASH }} {{ formatCurrentDate(DATE_FORMAT.EU_FORMAT_DASH) }}
          </option>
          <option :value="DATE_FORMAT.EU_FORMAT_DOT">
            {{ formatCurrentDate(DATE_FORMAT.EU_FORMAT_DOT) }}
          </option>
          <option :value="DATE_FORMAT.US_FORMAT">
            {{ formatCurrentDate(DATE_FORMAT.US_FORMAT) }}
          </option>
          <option :value="DATE_FORMAT.US_FORMAT_DASH">
            {{ formatCurrentDate(DATE_FORMAT.US_FORMAT_DASH) }}
          </option>
          <option :value="DATE_FORMAT.US_FORMAT_DOT">
            {{ formatCurrentDate(DATE_FORMAT.US_FORMAT_DOT) }}
          </option>
          <option :value="DATE_FORMAT.US_LONG">
            {{ formatCurrentDate(DATE_FORMAT.US_LONG) }}
          </option>
          <option :value="DATE_FORMAT.EU_LONG">
            {{ formatCurrentDate(DATE_FORMAT.EU_LONG) }}
          </option>
          <option :value="DATE_FORMAT.WEEKDAY">{{ formatCurrentDate(DATE_FORMAT.WEEKDAY) }}</option>
          <option :value="DATE_FORMAT.MONTH">{{ formatCurrentDate(DATE_FORMAT.MONTH) }}</option>
          <option :value="DATE_FORMAT.NO_DAY_LONG">
            {{ formatCurrentDate(DATE_FORMAT.NO_DAY_LONG) }}
          </option>
          <option :value="DATE_FORMAT.YEAR">{{ formatCurrentDate(DATE_FORMAT.YEAR) }}</option>
          <option :value="DATE_FORMAT.DAY">{{ formatCurrentDate(DATE_FORMAT.DAY) }}</option>
          <option :value="DATE_FORMAT.DAY_NAME">
            {{ formatCurrentDate(DATE_FORMAT.DAY_NAME) }}
          </option>
        </select>
      </div>
    </template>
  </Modal>
</template>

<script>
  import moment from 'moment-timezone';

  import Modal from '@/components/common/Modal.vue';

  import { DATE_WIDGET_TYPE, DATE_FORMAT, dateDefaultOptions } from '@/constant/dateWidget';

  export default {
    name: 'CreateDateWidgetModal',

    components: {
      Modal,
    },

    data() {
      return {
        widgetName: dateDefaultOptions.name,
        widgetType: dateDefaultOptions.type,
        language: dateDefaultOptions.language,
        dateFormat: dateDefaultOptions.format,
        DATE_WIDGET_TYPE,
        DATE_FORMAT,
      };
    },

    methods: {
      createWidget() {
        const configData = {
          name: this.widgetName,
          date: {
            ...dateDefaultOptions,
            type: this.widgetType,
            language: this.language,
            format: this.dateFormat,
            textFont: 'Poppins',
            textSize: 10,
            numbersSize: 12,
            fontColor: '#000000',
          },
        };

        this.$emit('createWidget', configData);
        this.$emit('closeModal');
      },

      formatCurrentDate(format) {
        const today = new Date();
        moment.locale(this.language);
        const date = moment(today);

        return date.format(format);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .form-group {
    margin-bottom: 15px;
    padding: 0 4px;
  }
</style>
